import { z } from 'zod';

export const searchSchema = z.object({
  xprocess: z.string().optional(),
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional()
});

export const initialValues = {
  xprocess: '2'
};
